import { render } from "./BodyResults.vue?vue&type=template&id=b9ab3ef4"
import script from "./BodyResults.vue?vue&type=script&lang=js"
export * from "./BodyResults.vue?vue&type=script&lang=js"

import "./BodyResults.vue?vue&type=style&index=0&id=b9ab3ef4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__